import { GenericElementsEvent } from './generic-elements-event';

export class GenericElementsHaveChangesEvent extends GenericElementsEvent {

}
